import ShopEntity from './base.js';
// import mpro from '../mpro.init';


/**
 * @param {import('../ajax-entities/inventory').MpApiLookupItem[]} items
 * @param {Map<string, import('../ajax-entities/inventory').MpApiLookupItem>=} itemsMap
 */
const serializedMap = (items, itemsMap) => {

	if (!itemsMap) {
		itemsMap = new Map();
	}

	for (const item of items) {

		const inventoryItem = {
			product_id: String(item.product_id),
		};

		if (item.qty) {
			inventoryItem.qty = String(item.qty);
		}

		itemsMap.set(JSON.stringify(inventoryItem), inventoryItem);
	}

	return itemsMap;
};

export default class Inventory extends ShopEntity {

	/**
	 * @typedef {(resp: import('../ajax-entities/inventory').MpApiLookupResponseData) => void} MpLookupDelayedCallback
	 * @typedef {{ items: import('../ajax-entities/inventory').MpApiLookupItem[], callback: MpLookupDelayedCallback }} MpLookupData
	 */

	static get NAME() {
		return 'Inventory';
	}

	/** @type {MpLookupData[]} */
	queue = [];
	/** @type {number} */
	timer;

	actions = {

		// Use base actions
		...this.actions,

		// Redirect to /inventory
		/** @type {import('./base').ShopActionHandler} */
		redirect_inventory: (args) => {
			mpro.setLocation(mpro.config.routes.inventory);
		},
	};

	constructor() {
		super();
		// Assign the api
		this.api = mpro.ajax.inventory;
	}

	availability_add(data) {
		return this.api.availability_add(data);
	}

	availability_delete(data) {
		return this.api.availability_delete(data);
	}

	userlist_set(data) {
		return this.api.userlist_set(data);
	}

	userlist_clear(data) {
		return this.api.userlist_clear(data);
	}
}
